module.exports = __webpack_public_path__ + "media/svg/ms-d5f65b2e.svg";